import React from 'react'

import { observer } from 'mobx-react'
import BookkeepingManagerDetailsViewModel from '../BookkeepingManagerDetailsViewModel'
import { BookkeepingManagerAction } from 'admin/bookkeeping/BookkeepingPendingAction'
import Button from 'components/Button'

import styles from './DetailsFooter.sass'
import link from 'infra/link'
import { Id } from 'types/definitions'

interface DetailsFooterProps {
  vm: BookkeepingManagerDetailsViewModel
}

export default observer(function DetailsFooter({ vm }: DetailsFooterProps) {
  return (
    <div className={styles.footer}>
      <div className={styles.actions}>
        {vm.bookkeepingPendingAction.action ===
          BookkeepingManagerAction.ConfirmAccess && (
          <ConfirmAccessButton vm={vm}></ConfirmAccessButton>
        )}

        {vm.bookkeepingPendingAction.action ===
          BookkeepingManagerAction.AssessmentReview && (
          <CompleteReviewButtons vm={vm} />
        )}
      </div>
    </div>
  )
})

interface ConfirmAccessButtonProps {
  vm: BookkeepingManagerDetailsViewModel
}

function ConfirmAccessButton({ vm }: ConfirmAccessButtonProps) {
  return (
    <Button
      onClick={vm.confirmAccess}
      type="primary"
      loading={vm.confirmAccess.pending}
      disabled={vm.confirmAccess.pending}
      data-test="bookkeeping-manager-details-confirm-access-button"
    >
      Confirm Access
    </Button>
  )
}

interface CompleteReviewButtonsProps {
  vm: BookkeepingManagerDetailsViewModel
}

function CompleteReviewButtons({ vm }: CompleteReviewButtonsProps) {
  return (
    <>
      <Button
        target="_blank"
        to={link.job(Id.assert(vm.bookkeepingPendingAction.id))}
      >
        View Job
      </Button>

      <Button
        onClick={vm.completeReview}
        type="primary"
        loading={vm.completeReview.pending}
        disabled={vm.completeReview.pending}
      >
        Complete Review
      </Button>
    </>
  )
}
